import React, { Fragment } from 'react';
import cn from 'classnames';
import { GQL } from '@gin-betting/core';
import { FormattedMessage } from 'react-intl';

import { getByKey } from 'utils';
import GameLogo from '../GameLogo';
import message from './messages';
import './promoHeader.scss';

interface Props {
    sportId: string;
    type: GQL.BannerType;
    isColorful?: boolean;
}

const PromoHeader: React.FC<Props> = ({ sportId, type, isColorful }) => {
    return (
        <div styleName="container">
            <div styleName="logo">
                <GameLogo gameId={sportId} />
            </div>
            {!isColorful && <PromoHeaderLabel type={type} />}
        </div>
    );
};

const PromoHeaderLabel: React.FC<Pick<Props, 'type'>> = ({ type }) => {
    const isEventOfTheDay = [
        GQL.BannerType.betting_live_of_the_day,
        GQL.BannerType.betting_match_of_the_day,
    ].includes(type);

    const msgDesc = getByKey(message, type.toLowerCase());

    return (
        <div
            styleName={cn('label ', {
                live: type === GQL.BannerType.betting_live_of_the_day,
            })}
            className="__app-PromoHeaderLabel-label"
        >
            {msgDesc && <FormattedMessage {...msgDesc} />}
            {isEventOfTheDay && (
                <Fragment>
                    {' '}
                    <FormattedMessage {...message.ofTheDay} />
                </Fragment>
            )}
        </div>
    );
};

export default React.memo(PromoHeader);
